import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8.494 6.858a1.424 1.424 0 0 0-1.997 0 1.373 1.373 0 0 0 0 1.957c.55.545 1.446.545 1.997 0a1.373 1.373 0 0 0 0-1.957Zm-2.982-.995a2.824 2.824 0 0 1 3.967 0 2.773 2.773 0 0 1 0 3.947 2.824 2.824 0 0 1-3.967 0 2.773 2.773 0 0 1 0-3.947Zm8.33 1.206a.818.818 0 1 0-1.157 1.156.818.818 0 0 0 1.157-1.156Zm-2.147-.99a2.218 2.218 0 1 1 3.137 3.137 2.218 2.218 0 0 1-3.137-3.137Zm.11 4.891a.7.7 0 0 1 .7-.7h2.277c1.225 0 2.218.994 2.218 2.219v.38a.7.7 0 1 1-1.4 0v-.38a.818.818 0 0 0-.818-.819h-2.277a.7.7 0 0 1-.7-.7Zm-6.418 1.476a.978.978 0 0 0-.987.97v.835a.7.7 0 1 1-1.4 0v-.835a2.378 2.378 0 0 1 2.387-2.37h4.217a2.378 2.378 0 0 1 2.386 2.37v.835a.7.7 0 1 1-1.4 0v-.835c0-.53-.435-.97-.986-.97H5.387Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
